import { BASE_PATH } from './constans';

export default function backendUrl(path: string) {
  const api = `${BASE_PATH}/api/rest/portal/`;
  return api + path;
}
